// 改寫自姊妹專案 pixi_slot（FaFaCat 移植案）已驗證的 src/framework/net/netLog.ts。
// 姊妹專案版本會把 Data payload 依 cmd 對應到特定 Protobuf 型別（Gateway.DeviceInfo／
// Slot001FaFaCat.SlotResult 等）解碼後印出——這些型別對本專案而言尚未確認
// （見 docs/PROTOBUF_SCHEMA.md），因此本版本只印出信封層欄位與 hex，Data 內容維持不透明。
//
// 後端通訊內容日誌 — 印出送出前 / 解密後的封包：cmd、RequestId、長度、hex。
// DEV 預設開；production build 需設 VITE_LOG_NET=true 才會輸出（以 console.info 直接印，
// 不受 logger 等級限制，故 build 版也看得到）。以 VITE_LOG_NET=false 可強制關閉。
import type { ResponsePacket } from './PacketCodec'

const ENABLED =
  import.meta.env['VITE_LOG_NET'] !== 'false' &&
  (import.meta.env.DEV || import.meta.env['VITE_LOG_NET'] === 'true')

// 專用輸出通道（不經 logger 等級，確保 build 版啟用時也會印）。
function out(...args: unknown[]): void {
  console.info('[Slot026][NET]', ...args)
}

// hex 輸出上限（bytes），避免大封包洗版。
const HEX_MAX = 512

function toHex(bytes: Uint8Array): string {
  const slice = bytes.subarray(0, HEX_MAX)
  const s = Array.from(slice, (b) => b.toString(16).padStart(2, '0')).join(' ')
  return bytes.length > HEX_MAX ? `${s} …(+${bytes.length - HEX_MAX}B)` : s
}

/** 印出送出後端的明文封包（payload 為加密前的內層 bytes，內容對本模組不透明）。 */
export function logSend(cmd: string, requestId: string, payload: Uint8Array): void {
  if (!ENABLED) return
  out(`📤 送出 cmd=${cmd} req=${requestId} len=${payload.length}`)
  out(`   hex: ${toHex(payload)}`)
}

/** 印出收到並解密後的 ResponseInfo（信封欄位 + hex，Data 內容對本模組不透明）。 */
export function logRecv(res: ResponsePacket): void {
  if (!ENABLED) return
  const head =
    `📥 收到 cmd=${res.cmd} code=${res.code}` +
    (res.message ? ` msg="${res.message}"` : '') +
    ` req=${res.requestId}` +
    (res.balance !== 0n ? ` balance=${res.balance}` : '') +
    (res.currency ? ` currency=${res.currency}` : '') +
    (res.txnId ? ` txnId=${res.txnId}` : '') +
    (res.totalWin !== 0n ? ` totalWin=${res.totalWin}` : '') +
    ` dataLen=${res.data.length}`
  out(head)
  if (res.data.length === 0) return
  out(`   hex: ${toHex(res.data)}`)
}
